import React, { Component } from 'react'
import { aTasks } from 'utils/aUtils'
import DataSyncTable from 'components/dataSyncTable'
import DataTable from 'components/dataTable'

export default class TaskTable extends Component {

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const CellType = DataTable.CellType
    const map = { true: '啟用中', false: '停用中' }
    const taskSchemas = [
      { type: CellType.input, title: '內容代碼', key: 'name', width: '10em' },
      { type: CellType.dropDown, title: '狀態', key: 'isEnabled', width: '5em', map },
    ]

    return (
      <DataSyncTable
        dataUtil={aTasks}
        schemas={taskSchemas}
        radioKey="isEnabled"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/taskTable.jsx